import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import TitleMixin from './mixins/TitleMixin'

const app = createApp(App).use(router)

app.mixin(TitleMixin)

app.mount('#app')